import React, { useEffect, useRef, useState } from "react";

import { Content, Card } from "./styles";
import { Container } from "../../../styles/GlobalStyles";

import Header from "../../../components/Header";
import Modal from "../../../components/Modal";
import { getUsuario } from "../../../services/security";
import {
  isStrongPassword,
  mascaraCelular,
  mascaraCnpj,
} from "../../../services/utils";
import Input from "../../../components/Input";
import { api } from "../../../services/api";
import Alerts from "../../../components/Alerts";
import { set } from "date-fns";
import InputPassword from "../../../components/InputPassword";

function AlterarSenha({ handleClose, empresaId, setMensagem }) {
  const btnEnviarRef = useRef();

  const [form, setForm] = useState({
    oldPassword: "",
    newPassword: "",
  });

  const [errorsMessages, setErrorsMessages] = useState({
    newPassword: "",
  });

  const handlerOldPassword = (e) => {
    setForm({ ...form, oldPassword: e.target.value });
  };

  const handlerNewPassword = (e) => {
    setForm({ ...form, newPassword: e.target.value });

    if (!isStrongPassword(e.target.value))
      setErrorsMessages((e) => ({
        ...e,
        newPassword: "A senha precisa ser forte",
      }));
    else
      setErrorsMessages((e) => ({
        ...e,
        newPassword: "",
      }));
  };

  //habilita / desabilita botão
  useEffect(() => {
    const formProps = Object.values(form);
    const errorsProps = Object.values(errorsMessages);

    let buttonDisabled = true;

    formProps.some((p) => {
      if (p === "") {
        buttonDisabled = true;
        return true;
      }
      buttonDisabled = false;
      return false;
    });

    if (!buttonDisabled) {
      errorsProps.some((p) => {
        if (p !== "") {
          buttonDisabled = true;
          return true;
        }
        buttonDisabled = false;
        return false;
      });
    }

    btnEnviarRef.current.disabled = buttonDisabled;
  }, [form, errorsMessages]);

  const changePasswordApi = async (e) => {
    e.preventDefault();

    btnEnviarRef.current.innerHTML = "Enviando...";
    btnEnviarRef.current.disabled = true;

    try {
      await api.put(`empresas/${empresaId}/senha`, form);

      btnEnviarRef.current.innerHTML = "OK!";
      btnEnviarRef.current.disabled = false;

      setTimeout(() => {
        setMensagem({
          show: true,
          titulo: "Sucesso",
          detalhe: "Senha alterada.",
          tipo: "sucesso",
        });
        handleClose();
      }, 500);
    } catch (e) {
      let msgErro = { show: true, titulo: "Erro", tipo: "erro" };
      if (e.response) msgErro.detalhe = e.response.data.erro;
      else
        msgErro.detalhe =
          "Desculpe, houve um problema. Tente novamente mais tarde.";
      btnEnviarRef.current.innerHTML = "Enviar";
      btnEnviarRef.current.disabled = false;
      setMensagem(msgErro);
    }
  };

  return (
    <form
      onSubmit={changePasswordApi}
      style={{ marginTop: 20, display: "flex", flexDirection: "column" }}
    >
      <InputPassword
        placeholder="* * * * * *"
        label="Senha antiga"
        maxLength={300}
        id="oldPassword"
        value={form.oldPassword}
        handler={handlerOldPassword}
        mensagemErro={""}
        required
      />
      <InputPassword
        type="text"
        placeholder="* * * * * *"
        label="Nova senha"
        maxLength={300}
        id="newPassword"
        value={form.newPassword}
        handler={handlerNewPassword}
        tip="Deve conter no mínimo 8 caracteres, letras maiúsculas e minúsculas, números e símbolos."
        mensagemErro={errorsMessages.newPassword}
        required
      />
      <button ref={btnEnviarRef}>Alterar</button>
    </form>
  );
}

function Perfil() {
  const headerLinks = [{ label: "Sair", to: "/" }];

  const [showChangePassword, setShowChangePassword] = useState(false);
  const [mensagem, setMensagem] = useState(undefined);

  const empresa = getUsuario();

  return (
    <Container>
      <Alerts
        mensagem={mensagem}
        setMensagem={setMensagem}
        tipo={mensagem?.tipo}
      />
      <Header links={headerLinks} theme="black" />
      {showChangePassword && (
        <Modal
          title="Alterar senha"
          handleClose={() => setShowChangePassword(false)}
        >
          <AlterarSenha
            empresaId={empresa.id}
            setMensagem={setMensagem}
            handleClose={() => setShowChangePassword(false)}
          />
        </Modal>
      )}
      <Content>
        <h1>Perfil</h1>
        <Card>
          <label>Nome da empresa</label>
          <p>{empresa.nome}</p>

          <label>CNPJ</label>
          <p>{mascaraCnpj(empresa.cnpj)}</p>

          <label>Seu nome</label>
          <p>{empresa.nome_contato}</p>

          <label>Seu E-mail</label>
          <p>{empresa.email_contato}</p>

          <label>Seu Telefone</label>
          <p>{mascaraCelular(empresa.telefone_contato)}</p>

          <button
            style={{ marginTop: 30 }}
            onClick={() => setShowChangePassword(true)}
          >
            Alterar Senha
          </button>
        </Card>
      </Content>
    </Container>
  );
}

export default Perfil;
